var _excluded = ["counter", "to", "href", "title", "isLoading", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { memo, useContext, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import BrandContext from "../../../../../../contexts/BrandContext";
import OnColorContext from "../../../../../../contexts/OnColorContext";
import pageHeaderBrandStyles from "../../../../../../theme/pageHeaderBrandStyles";
import breakpoint from "../../../../../../utils/breakpoint";
import getBorderRadius from "../../../../../../utils/getBorderRadius";
import getBoxShadow from "../../../../../../utils/getBoxShadow";
import getColor from "../../../../../../utils/getColor";
import getIconColor from "../../../../../../utils/getIconColor";
import isServer from "../../../../../../utils/isServer";
import space from "../../../../../../utils/space";
import transition from "../../../../../../utils/transition";
import unit from "../../../../../../utils/unit";
import { cssTextAtm } from "../../../../../atoms/TextAtm/TextAtm.styled";
import Link from "../../../../../quarks/Link";
import BreakpointVisibilityOrg from "../../../../BreakpointVisibilityOrg";
var CartSvg = function CartSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.037 4.73a1 1 0 0 1 1.234-.693l3.136.883a1 1 0 0 1 .726.889L6.11 19h14.965l1.941-10.65a1 1 0 1 1 1.968.359l-2.091 11.47a1 1 0 0 1-.984.821H5.182a1 1 0 0 1-.998-.926L3.191 6.655.729 5.963a1 1 0 0 1-.692-1.234ZM9.022 25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM19.891 25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  }))));
};
CartSvg.defaultProps = {
  width: "26",
  height: "26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var EmptyCartSvg = function EmptyCartSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "2",
    fill: "#4D5B68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "21",
    r: "2",
    fill: "#4D5B68"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2a1 1 0 0 0 0 2h1.824C2.92 4 3 4.079 3 4.176V17a1 1 0 0 0 1 1h13.691a1 1 0 0 0 .959-.715l2.969-10A1 1 0 0 0 20.66 6H5V4.176A2.176 2.176 0 0 0 2.824 2H1Zm4 14V8h14.32l-2.375 8H5Z",
    fill: "#4D5B68"
  }));
};
EmptyCartSvg.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var FullCartSvg = function FullCartSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "21",
    r: "2",
    fill: "#4D5B68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "21",
    r: "2",
    fill: "#4D5B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3a1 1 0 0 1 1-1h1.824C4.026 2 5 2.974 5 4.176V6h8.207a5.507 5.507 0 0 0-.185 2H5v8h11.945l.902-3.038a5.541 5.541 0 0 0 2.135-.164l-1.332 4.487a1 1 0 0 1-.959.715H4a1 1 0 0 1-1-1V4.176A.176.176 0 0 0 2.824 4H1a1 1 0 0 1-1-1Z",
    fill: "#4D5B68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "3",
    width: "9",
    height: "9",
    rx: "4.5",
    fill: "#E20000"
  }));
};
FullCartSvg.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var buttonSizeSpace = 5;
var buttonBackgroundColor = "backgroundLight";
var primaryColor = "primary";
var counterSize = 15;
var Button = styled(Link).withConfig({
  componentId: "sc-wadkyq-0"
})(function (_ref) {
  var theme = _ref.theme;
  return css(["display:flex;position:relative;align-items:center;justify-content:center;width:", ";height:", ";", "{", ";border-radius:", ";background-color:", ";box-shadow:", ";&:hover{box-shadow:", ";}}"], space(buttonSizeSpace), space(buttonSizeSpace), breakpoint("medium"), transition("box-shadow"), getBorderRadius(theme, "huge"), getColor(theme, buttonBackgroundColor), getBoxShadow(theme, "tiny"), getBoxShadow(theme, "medium"));
});
var CartIcon = styled(CartSvg).withConfig({
  componentId: "sc-wadkyq-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["fill:", ";"], getIconColor(theme, buttonBackgroundColor, "high"));
});
var EmptyCartIcon = styled(EmptyCartSvg).withConfig({
  componentId: "sc-wadkyq-2"
})(function (_ref3) {
  var theme = _ref3.theme,
    $onColor = _ref3.$onColor;
  return css(["circle,path{fill:", ";}"], getIconColor(theme, $onColor, "high"));
});
var FullCartIcon = styled(FullCartSvg).withConfig({
  componentId: "sc-wadkyq-3"
})(function (_ref4) {
  var theme = _ref4.theme,
    $onColor = _ref4.$onColor;
  return css(["rect{fill:", ";}circle,path{fill:", ";}"], getColor(theme, primaryColor), getIconColor(theme, $onColor, "high"));
});
var Counter = styled.span.withConfig({
  componentId: "sc-wadkyq-4"
})(function (_ref5) {
  var $background = _ref5.$background,
    $isLoading = _ref5.$isLoading,
    theme = _ref5.theme;
  return css(["", ";display:flex;position:absolute;top:", ";left:", ";align-items:center;justify-content:center;width:", ";height:", ";border-radius:", ";background:", ";", ""], cssTextAtm({
    typography: "nano3",
    onColor: $background
  }), unit(10), unit(13), unit(counterSize), unit(counterSize), getBorderRadius(theme, "small"), getColor(theme, $background), $isLoading && css(["font-size:0;&::after{content:\"\";width:", ";height:", ";background:", ";border-radius:", ";}"], space(0.5), space(0.5), getIconColor(theme, $background), getBorderRadius(theme, "huge")));
});
function CartButtonAtm(_ref6) {
  var counter = _ref6.counter,
    to = _ref6.to,
    href = _ref6.href,
    title = _ref6.title,
    isLoading = _ref6.isLoading,
    onClick = _ref6.onClick,
    restProps = _objectWithoutProperties(_ref6, _excluded);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    basketCounter = _useState2[0],
    setBasketCounter = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    basketLoading = _useState4[0],
    setBasketLoading = _useState4[1];
  var cartButtonCounterBackground = pageHeaderBrandStyles[useContext(BrandContext)].cartButtonCounterBackground;
  var onColor = useContext(OnColorContext);
  useEffect(function () {
    if (!isServer()) {
      setBasketCounter(counter);
      setBasketLoading(!!isLoading);
    }
  }, [counter, isLoading]);
  var detailedCartJsx = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CartIcon, null), /*#__PURE__*/React.createElement(Counter, {
    $background: cartButtonCounterBackground,
    $isLoading: !!basketLoading
  }, basketCounter));
  var basicCartJsx = !basketLoading && basketCounter >= 1 ? /*#__PURE__*/React.createElement(FullCartIcon, {
    $onColor: onColor
  }) : /*#__PURE__*/React.createElement(EmptyCartIcon, {
    $onColor: onColor
  });
  return /*#__PURE__*/React.createElement(Button, _extends({
    to: to,
    href: href,
    title: title,
    "aria-label": title,
    onClick: onClick
  }, restProps), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, basicCartJsx), /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, detailedCartJsx));
}
export default /*#__PURE__*/memo(CartButtonAtm);